import styled from 'styled-components';
import { StyleColor } from '../../../utils/styles-constants';

interface ContainerProps {
	isDisplayed: boolean;
}

const Container = styled('div')`
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	background-color: ${StyleColor.White};
	z-index: 500;
	opacity: 1;

	transition: opacity 200ms, bottom 200ms;
	${(props: ContainerProps) => props.isDisplayed
		? `opacity: 1;
			bottom: 0;`
		: `opacity: 0;
			bottom: -100px;
			pointer-events:none;`
	}

	@media(max-width: 1200px) {
		flex-direction: column;
	}

	@media print {
		display: none;
	}
`;

const Message = styled('div')`
	font-size: 15px;
	color: ${StyleColor.Grey800};
`;

const Group = styled('div')`
	margin-left: 20px;

	@media(max-width: 1200px) {
		padding-top:10px;
		margin: 0;
	}
`;

const ButtonAllowAll = styled('button')`
	padding: 5px 10px;
	background-color: ${StyleColor.Grey800};
	color: ${StyleColor.White};
	border: 0;
	border-radius: 3px;
	margin-right: 20px;
	cursor: pointer;
`;

const ButtonPersonalize = styled('button')`
	padding: 5px 10px;
	background-color: transparent;
	color: ${StyleColor.Grey800};
	border: 1px solid ${StyleColor.Grey800};
	border-radius: 3px;
	cursor: pointer;
`;

const ButtonPrivacyPolicy = styled('button')`
	border: 0;
	background-color: transparent;
	color: ${StyleColor.Grey800};
	cursor: pointer;
`;

const ButtonRejectAll = styled('button')`
	background-color: transparent;
	border: 0;
	color: ${StyleColor.Grey800};
	text-align: center;
	cursor: pointer;
`;

export {
	Container,
	Message,
	Group,
	ButtonAllowAll,
	ButtonPersonalize,
	ButtonPrivacyPolicy,
	ButtonRejectAll,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CookieNotification/GDPRCookie/styles.ts